<template>
  <div class="theme-toggle" @click="toggleTheme" :title="isDark ? '切换到浅色模式' : '切换到深色模式'">
    <i :class="isDark ? 'el-icon-sunny' : 'el-icon-moon'"></i>
    <span class="theme-label">{{ isDark ? '浅色' : '深色' }}</span>
  </div>
</template>

<script>
import ThemeManager from '@/utils/theme.js'

export default {
  name: 'ThemeToggle',
  data() {
    return {
      isDark: false
    }
  },
  created() {
    this.isDark = ThemeManager.isDark()
    this.unsubscribe = ThemeManager.subscribe((isDark) => {
      this.isDark = isDark
    })
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  methods: {
    toggleTheme() {
      this.isDark = ThemeManager.toggle()
      this.$emit('theme-changed', this.isDark)
    }
  }
}
</script>

<style scoped>
.theme-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  color: var(--text-regular, #606266);
  user-select: none;
}

.theme-toggle:hover {
  background-color: var(--bg-table-hover, #f5f7fa);
}

.theme-toggle i {
  font-size: 18px;
  margin-right: 6px;
}

.theme-label {
  font-size: 14px;
}
</style>
